import { FocusMonitor } from '@angular/cdk/a11y';
import {
  Component,
  ElementRef,
  Input,
  Optional,
  Self,
  AfterViewInit,
} from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';

import { BaseMatControlComponent } from '../../base-mat-control.component';

@Component({
  selector: 'app-easy-textarea',
  templateUrl: './easy-textarea.component.html',
  styleUrls: ['./easy-textarea.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EasyTextareaComponent },
  ],
})
export class EasyTextareaComponent
  extends BaseMatControlComponent<string | null | undefined>
  implements AfterViewInit
{
  @Input() resizable = true;
  @Input() maxLength?: number;
  @Input() showCharactersLeft = false;
  @Input() rows = 4;

  constructor(
    @Optional() @Self() public override ngControl: NgControl,
    protected override formBuilder: FormBuilder,
    protected override focusMonitor: FocusMonitor,
    protected override elRef: ElementRef
  ) {
    super(ngControl, formBuilder, focusMonitor, elRef);

    this.controlIdentity = 'easy-textarea';
    this.controlType = 'textarea';
  }

  get maxLength1() {
    return this.maxLength ?? this.ngControl.validator;
  }

  ngAfterViewInit(): void {
    this.userAriaDescribedBy = `${this.id}-required-error ${this.id}-max-error`;
  }
}
